export default {
    VISA_MC_P2P: 'Visa/MC P2P',
    VISA_MC_WW: 'Visa/MC Worldwide',
    VISA_MC: 'Visa/MC',
    MOBILE_PHONE: 'Mobile',
    QIWI: 'Qiwi',
    ADVCASH: 'ADVCash',
    PAYEER: 'Payeer',
    PERFECT_MONEY: 'Perfect money',
    CAPITALIST: 'Capitalist',
    WEBMONEY: 'WebMoney',
    YANDEX_MONEY: 'YooMoney'
}